import Axios from "axios";
import ENV from "@/utils/constants/environment";
import { AuthErrorHandler } from "@/plugins/error-handler";

const AxiosInstance = (resType: any = undefined) => {
  const token = localStorage.getItem("token");

  const axiosInstance = Axios.create({
    baseURL: ENV.API_URL,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    },
    responseType: resType
  });
  // TODO: Generic error handling
  axiosInstance.interceptors.response.use(
    response => response,
    error => AuthErrorHandler(error)
  );
  return axiosInstance;
};

export default AxiosInstance;
